import type { MessageAttachment } from './attachments';

export enum MessageStatus {
  PENDING = 'pending',
  SENT = 'sent',
  ERROR = 'error'
}

export enum TextFormat {
  HTML = 'html'
}

export interface IMessage {
  id: string;
  text: string;
  date: Date;
  isBot: boolean;
  status?: MessageStatus;
  attachments?: MessageAttachment[];
  isWelcome?: boolean;
  textFormat?: TextFormat;
}

/**
 * Данные вложения для отправки сообщения.
 * Содержит серверный ID для API и метаданные для temp-сообщения.
 */
export interface SendAttachment {
  id: string;
  filename: string;
  size: number;
  type: string;
  url: string;
  preview_url?: string;
  width?: number;
  height?: number;
}
